import { FinMasonError } from "@fartherfinance/frontend/api/Investment/types";

import { typedKeys } from "@src/multiCustodian/utils/arrayHelpers";

function formatFinMasonError(error: unknown): string {
  if (error instanceof FinMasonError) {
    const invalidSecuritiesList = typedKeys(error.invalidPositions)
      .map((key) => key)
      .join(",\n");

    return invalidSecuritiesList.length > 0
      ? `${error.message}: \n${invalidSecuritiesList}`
      : error.message;
  }

  return "Unknown error";
}

export default formatFinMasonError;
